import { useMemo } from 'react';

import { BiometryType } from '@capgo/capacitor-native-biometric';

import { useAuthWithBiometryV5ProcessContext } from '@liscio/common';
import { Icon, InputAdornment, IconButton, FaceIDIcon } from '@liscio/ui';

export const BiometricsAdornment = () => {
  const { isBiometricLoginEnabled, biometryType, biometricSignIn } =
    useAuthWithBiometryV5ProcessContext();

  const biometricIcon = useMemo(() => {
    switch (biometryType) {
      case BiometryType.FACE_ID:
      case BiometryType.FACE_AUTHENTICATION:
        return <FaceIDIcon fontSize="large" />;
      case BiometryType.TOUCH_ID:
      case BiometryType.FINGERPRINT:
      case BiometryType.MULTIPLE:
        return <Icon icon="fingerprint" fontSize="large" />;
    }
  }, [biometryType]);

  if (!isBiometricLoginEnabled) {
    return undefined;
  }

  return (
    <InputAdornment position="end" style={{ color: 'inherit', marginRight: 0 }}>
      <IconButton onClick={biometricSignIn} edge="end" color="inherit">
        {biometricIcon}
      </IconButton>
    </InputAdornment>
  );
};

export default BiometricsAdornment;
